import { mapState } from 'vuex';

// @vuese
// Mixin komponentu opakowującego renderowany formularz
export const formRenderContainerMixin = {
  schema: {},
  computed: mapState({
    schemaName: state => state.schema.data && state.schema.data.name,
    schema: state => state.schema.data && JSON.parse(state.schema.data.schema)
  }),
  data() {
    return {
      model: {},
      loadedSchema: false
    };
  },
  methods: {
    // @vuese
    // Ładuje schemę
    loadSchema() {
      this.model = {};
      this.$setSchema(this.schema);
      if (this.setData) {
        this.setData(this.stateData);
      }
      if (this.$schema) {
        this.$schema.$reset();
      }
      this.loadedSchema = true;
    }
  },
  mounted() {
    this.loadSchema();
  }
};
